export default "__VITE_ASSET__BmnSCvvh__"